module.exports = __webpack_public_path__ + "media/images/ilustrations/ilustration-3-d9525427486c3aa59e1b68fb2a460b72.png";